import { Output } from "valibot";

import {
  IntegrationCredentialsSchema,
  IntegrationOptionsSchema,
} from "components/SonicBot/schemas";
import { AppConfiguration } from "shared/types";

export abstract class IntegrationHandler {
  name: string;
  type: string;
  id: string;
  required_user_fields?:string;
  data: { [key: string]: string };

  constructor(options: Output<typeof IntegrationOptionsSchema>) {
    this.name = options.name;
    this.type = options.type;
    this.id = options.id;
    this.data = {};
  }

  getButtonName(): string {
    return this.name;
  }

  getType(): string {
    return this.type;
  }

  getAskableQuestions(): string[] {
    return [];
  }

  abstract run(
    onIntegrationClick: (integration: IntegrationHandler) => Promise<void>,
    config: AppConfiguration,
    botId: string,
  ): Promise<void>;
}

export abstract class BaseIntegrationHandler {
  name: string;
  description: string;
  icon: string;
  credentials: Output<typeof IntegrationCredentialsSchema>;
  integration_type: "button" | "text";
  is_active: boolean;
  button_name: string;

  constructor() {
    this.name = "Base Integration";
    this.description = "Base Integration";
    this.icon = "Base Integration";
    this.credentials = {};
    this.integration_type = "button";
    this.is_active = false;
    this.button_name = "Base Integration";
  }

  /**
   * Runs the integration.
   */

  getButtonName(): string {
    return this.button_name;
  }

  run(): void {
    throw new Error("Not implemented");
  }
  stop(): void {
    throw new Error("Not implemented");
  }
}

export class DefaultIntegrationHandler extends IntegrationHandler {
  constructor(options: IntegrationHandler) {
    super(options);
    Object.assign(this, options);
  }

  async run(
    onIntegrationClick: (integration: IntegrationHandler) => Promise<void>,
    config: AppConfiguration,
    botId: string,
  ): Promise<void> {
    throw new Error("Not implemented");
  }
}
